import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'

export const priceBreaksPivotTableKey = 'priceListsContext.part.priceBreaks.pivotTable'

export default combineReducers({
    pivotTable: createPivotTableReducer({
        key: priceBreaksPivotTableKey,
        defaultSortColumn: 'minPacks'}),
  }
)
